import React, { Component } from "react";
import styled from "@emotion/styled";
import colors from "styles/colors";
import dimensions from "styles/dimensions";
import { Inner } from "styles/structure";
import SectionHeading from "components/_ui/SectionHeading";
import ArrowLink from 'components/_ui/ArrowLink';

const PositionsContainer = styled.div`
  & + * {
    margin-top: 8rem;
  }

  &:last-of-type {
    margin-bottom: 8rem;
  }

  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 14.4rem;
    }  

    &:last-of-type {
      margin-bottom: 14.4rem;
    }
  }
`;

const PositionsContent = styled.ul`
  max-width: 84.8rem;
  border-top: 1px solid ${colors.grey300};
  margin-top: 6.4rem;
  
  li {
    border-bottom: 1px solid ${colors.grey300};
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    margin-top: 8rem;
  }
`;

const Position = styled.div`
  padding: 3.2rem 0;
  color: ${colors.grey900};
  
  span {
    font-size: 1.6rem;
  }
  
  h4 {
    font-weight: 400;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    a {
      position: relative;
      right: 4rem;
    }
  }
`;

class Positions extends Component {
  render() {
    return (
      <PositionsContainer>
        <Inner>
          <SectionHeading>{this.props.heading}</SectionHeading>

          <PositionsContent>
            {this.props.positions.map((position, i) => (
              <li key={i}>
                <Position>
                  <div>
                    {position.position && <h4>{position.position}</h4>}
                    {position.location && <span>{position.location}</span>}
                  </div>

                  {position.external_url && (
                    <ArrowLink
                      external
                      text='Apply'
                      href={position.external_url}
                      target='_blank'
                      rel='noopener noreferrer'
                    />
                  )}
                </Position>
              </li>
            ))}
          </PositionsContent>
        </Inner>
      </PositionsContainer>
    );
  }
}

export default Positions;
